import { Pdp } from '@ff-os/pdp-shared-registry/Pdp';
import { photoPrintsPluginReducers } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { close } from './close';
import { PhotoPrintsModalUi } from './PhotoPrintsModalUi';
import { PhotoPrintsUi } from './PhotoPrintsUi';
import { renderProjectToThumbnail } from './renderProjectToThumbnail';
import { show } from './show';
import { addDesignChangeListener } from './startup/addDesignChangeListener';
import { getProjectExportStatus } from './startup/getProjectExportStatus';
import { initializeProject } from './startup/initializeProject';
import { openProject } from './startup/openProject';
import { startup } from './startup/startup';
import { toOutputs } from './toOutputs';

export const photoPrintsPdpPlugin: Pdp.Scene.Plugin<PhotoPrintsJson.Project> = {

    pluginId: 'photo-prints',

    ui: {
        preview: null,
        designer: PhotoPrintsUi,
        modal: PhotoPrintsModalUi
    },

    reducers: photoPrintsPluginReducers,
    startup: startup,

    show: show,
    close: close,

    toOutputs: toOutputs,
    renderThumbnail: renderProjectToThumbnail,

    addDesignChangeListener: addDesignChangeListener,

    project: {
        initialize: initializeProject,
        open: openProject,
        getExportStatus: getProjectExportStatus
    }
};